module.exports = __webpack_public_path__ + "components/star-rating/static/yellow/8-707df7738374c51c58083673ed372f97.svg";